<template>
  <b-form-group
    label="1. Kode Barang"
    label-for="kesesuaianKodeBarang"
    label-size="lg"
    label-class="pb-0 pt-0"
  >
    <b-form-radio
      v-for="(dataKesesuaianKobar, i) of dataKesesuaianKobars"
      :key="i"
      v-model="kesesuaianKodeBarang"
      :value="dataKesesuaianKobar.value"
      :state="stateKesesuaianKodeBarang"
      @change="changeKesesuaianKodeBarang"
    >
      {{ dataKesesuaianKobar.label }}
    </b-form-radio>
    <small
      v-for="(error, index) of errorsKesesuaianKodeBarang"
      :key="index"
      class="text-danger"
    >
      {{ error.$message }}
    </small>

    <b-col
      v-if="kesesuaianKodeBarang === '0'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-group
        label="KIB Seharusnya"
        label-for="kibSeharusnya"
        label-size="lg"
        label-class="pb-0 pt-0"
      >
        <b-form-select
          id="kibSeharusnya"
          v-model="kibSeharusnya"
          :state="stateKibSeharusnya"
          :options="dataKib"
          @change="changeKibSeharusnya"
        />
        <b-form-invalid-feedback
          v-for="(error, index) of errorsKibSeharusnya"
          :key="index"
        >
          {{ error.$message }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        label="Kode Barang Yang Seharusnya"
        label-for="kodeBarangSeharusnya"
        label-size="lg"
        label-class="pb-0 pt-0"
      >
        <b-overlay
          :show="isLoadDataKobar"
          variant="light"
          opacity="0.85"
          blur="2px"
          rounded="sm"
        >
          <v-select
            id="kodeBarangSeharusnya"
            v-model="kodeBarangSeharusnya"
            :options="dataKobar"
            label="text"
            @input="inputKodeBarangSeharusnya"
            @search="searchKodeBarangSeharusnya"
          />
          <small
            v-for="(error, index) of errorsKodeBarangSeharusnya"
            :key="index"
            class="text-danger"
          >
            {{ error.$message }}
          </small>
        </b-overlay>
      </b-form-group>
    </b-col>
  </b-form-group>
</template>

<script>
import { ref, watchEffect, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import master from '@/composables/master'
import {
  propsString,
  propsBoolean,
  propsArray,
  propsObject,
  propsFunction,
} from '@/utils/propsTipeData'

export default {
  setup(props, context) {
    const g = context.root

    const kesesuaianKodeBarang = ref('')
    const kibSeharusnya = ref(null)
    const kodeBarangSeharusnya = ref({
      text: '-- Pilih Salah Satu --',
      value: null,
    })
    const dataKib = ref([])
    const dataKobar = ref([])
    const isLoadDataKobar = ref(false)

    const getKobar = async (kobar = '', kolok = null, isLoad = true) => {
      if (isLoad) isLoadDataKobar.value = true

      dataKobar.value = await props.getKobarTemp({
        kib: kibSeharusnya.value ? kibSeharusnya.value : props.kibVal,
        cari: kobar,
        kolok,
        length: 20,
      })
      isLoadDataKobar.value = false
    }

    watch(kesesuaianKodeBarang, () => {
      context.emit('emitKodeBarang', kesesuaianKodeBarang.value)
    })

    watch(kibSeharusnya, () => {
      context.emit('emitKibSeharusnya', kibSeharusnya.value)
      getKobar('')
    })

    watch(kodeBarangSeharusnya, () => {
      context.emit('emitKodeBarangSeharusnya', kodeBarangSeharusnya.value)
    })

    watchEffect(() => {
      kesesuaianKodeBarang.value = props.kesesuaianKodeBarangVal
    })

    watchEffect(() => {
      kibSeharusnya.value = props.kibSeharusnyaVal
    })

    watchEffect(() => {
      kodeBarangSeharusnya.value = props.kodeBarangSeharusnyaVal
    })

    const changeKesesuaianKodeBarang = () => {
      if (kesesuaianKodeBarang.value == 0) getKobar()
      context.emit('emitChangeKesesuaianBarang')
    }

    const inputKodeBarangSeharusnya = () => {
      context.emit('emitInputKodeBarangSeharusnya', kodeBarangSeharusnya.value)
    }

    const getKib = async () => {
      const resKib = await master.getKib(g)
      resKib.unshift({ text: '-- Pilih Salah Satu --', value: null })
      dataKib.value = resKib
    }

    const searchKodeBarangSeharusnya = search => {
      getKobar(search, null, false)
    }

    const changeKibSeharusnya = () => {
      kodeBarangSeharusnya.value = {
        value: null,
        text: '-- Pilih Salah Satu --',
      }
    }

    getKib()

    return {
      kesesuaianKodeBarang,
      kibSeharusnya,
      kodeBarangSeharusnya,
      changeKesesuaianKodeBarang,
      changeKibSeharusnya,
      inputKodeBarangSeharusnya,
      searchKodeBarangSeharusnya,
      dataKib,
      dataKobar,
      isLoadDataKobar,
    }
  },
  components: {
    vSelect,
  },
  props: {
    kesesuaianKodeBarangVal: propsString,
    stateKesesuaianKodeBarang: propsBoolean,
    errorsKesesuaianKodeBarang: propsArray,
    kibSeharusnyaVal: propsString,
    stateKibSeharusnya: propsBoolean,
    errorsKibSeharusnya: propsArray,
    kodeBarangSeharusnyaVal: propsObject,
    stateKodeBarangSeharusnya: propsBoolean,
    errorsKodeBarangSeharusnya: propsArray,
    getKobarTemp: propsFunction,
  },
  data() {
    return {
      dataKesesuaianKobars: [
        { label: 'Sesuai Dengan Data Lama', value: '1' },
        { label: 'Tidak Sesuai Dengan Data Lama', value: '0' },
      ],
    }
  },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
